import Fetch from '../Fetch';

export default {
  queryPOEInfo: (params) => {
    return Fetch.get(`/api/v1/swcfg_poe`, { params });
  },
  setPOE: (params) => {
    return Fetch.post(`/api/v1/swcfg_poe`, params);
  },
  queryScheduleList: (params) => {
    return Fetch.get(`/api/v1/scheduleList`, { params });
  },
  setSchedule: (params) => {
    return Fetch.post(`/api/v1/sw_poe_schedule`, params);
  },
  updateSchedule: (params) => {
    return Fetch.post(`/api/v1/sw_poe_schedule`, params);
  },
  deleteSchedule: (params) => {
    return Fetch.delete(`/api/v1/sw_poe_schedule`, { params });
  },
  queryGlobalPoeInfo: (params) => {
    return Fetch.get(`/api/v1/swcfg_poe_info`, { params });
  },
  associationPoe: (params) => {
    return Fetch.post(`/api/v1/sw_port_schedule`, params);
  },
  updatePoeReset: (params) => {
    return Fetch.post(`/api/v1/swcfg_poe_reset`, params);
  }
};
